export const EditDrawerTestIds = {
  CHANGE_LOCATION_BUTTON: 'wire-to-info.change-location-button',
};
